import React from 'react';
import PropTypes from 'prop-types';
import BuilderInfo from '../containers/BuilderInfo';
import BuilderPublishButton from '../containers/BuilderPublishButton';
import BuilderUndoRedoButtons from '../containers/BuilderUndoRedoButtons';
import AdminHeader from '../containers/AdminHeader';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  controls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const defaultProps = {
  children: undefined,
  controls: undefined,
};

const BuilderHeader = ({ children, controls, ...rest }) => (
  <AdminHeader
    {...rest}
    controls={
      <React.Fragment>
        <BuilderInfo />
        <BuilderUndoRedoButtons />
        {controls}
        <BuilderPublishButton />
      </React.Fragment>
    }
  >
    {children}
  </AdminHeader>
);

BuilderHeader.propTypes = propTypes;
BuilderHeader.defaultProps = defaultProps;

export default BuilderHeader;
